export default "__VITE_ASSET__DtPis21W__"